import { CcfPhoneOutboundIcon, CcfSmsIcon, CcfWhatsAppIcon, CcfEmailIcon } from '@nice-ccf/ui-controls';

export const triggerTypes = {
    voice: {
        id: 1,
        type: 'voice',
        label: 'Voice Call',
        icon: CcfPhoneOutboundIcon
    },
    chat: {
        id: 2,
        type: 'chat',
        label: 'SMS',
        icon: CcfSmsIcon
    },
    whatsApp: {
        id: 3,
        type: 'whatsApp',
        label: 'SMS WhatsApp',
        icon: CcfWhatsAppIcon
    },
    email: {
        id: 4,
        type: 'email',
        label: 'Email',
        icon: CcfEmailIcon
    }
}
